import axiosInstance from "../CustomAxios/axiosInstance";

class ProblemService {

    async getProblems() {
        try {
        const response = await axiosInstance.get("/issues");
        return response.data;
        } catch (error) {
                throw error;
        }
    }
    async updateProblemStatus(problemId: number, newStatus: string) {
        try {
            const response = await axiosInstance.put(`/issues/${problemId}`, { status: newStatus });
            return response.data;
        } catch (error) {
                        throw error;
        }
    }
    
    async deleteProblem(problemId: number) {
        try {
            const response = await axiosInstance.delete(`/issues/${problemId}`);
            return response.data;
        } catch (error) {
                        throw error;
        }
    }
    
}


const problemService = new ProblemService();
export default problemService;
